import config from '@/config'

export default ($axios) => {
    return {
        getList() {
            const data = {
                action: '/store/get-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        addStore(param = {}) {
            const data = {
                param: param,
                action: '/store/add-store'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getStoreInfo(id) {
            const data = {
                id: id,
                action: '/store/get-store-info'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         updatePic(param) {
            const data = {
                param: param,
                action: '/store/update-pic'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         saveStoreInfo(param) {
            const data = {
                param: param,
                action: '/store/save-store-info'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         
         saveStoreUserOne(id,user_id) {
            const data = {
                id: id,
                user_id:user_id,
                action: '/store/save-store-user-one'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         saveStoreUserTwo(id,user_id) {
            const data = {
                id: id,
                user_id:user_id,
                action: '/store/save-store-user-two'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         delStoreUserTwo(id,user_id) {
            const data = {
                id: id,
                user_id:user_id,
                action: '/store/del-store-user-two'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
    }
}